<template>
    <div class="dashBoardVideoContainer" ref="animationContainer">
        <canvas ref="apngCanvas" width="700" height="540" class="img-fluid"></canvas>
    </div>
</template>

<script>
    import EventService     from '@/services/EventService.js'
    import parseAPNG from 'apng-js'

    export default {
        data() {
            return {
                animacie: [],
                loopAnimationPaused: false,

                animationSound: '',
                animationBubbleSound: '',
                animationBubbleText: '',

                apngCanvas: {},
                apngContext: {},

                srcLoopAnimacie: [],
                loopAnimations: [],

                srcActionAnimacie: [],
                actionAnimations: [],
                actionAnimationsNames: []
            }
        },
        mounted() {
            this.getAnimacie()
        },
        destroyed() {
            this.loopVideoPaused = true
        },
        computed: {
        },
        methods: {
            getAnimacie() {
                var array = EventService.getAnimacieFromSession()
                if (array == 'empty') {
                    EventService.getAnimacie()
                        .then(response => {
                            //console.log(response.data.data)
                            this.animacie = this.genAnimationSequence(response.data.data)
                            EventService.saveAnimacieToSession(JSON.stringify(this.animacie))
                            this.startLoopAnimations()
                        })
                        .catch(error => {
                            //console.log('There was an error:', error.response.data.error)
                            this.responseType = 'warning'
                            this.responseText = error.response.data.error
                        })

                } else {
                    //this.animacie = this.genAnimationSequence(JSON.parse(EventService.getAnimacieFromSession()))
                    this.animacie = JSON.parse(EventService.getAnimacieFromSession())
                    this.startLoopAnimations()
                }
            },

            genAnimationSequence(array) {
                var currentIndex = array.length, temporaryValue, randomIndex

                // While there remain elements to shuffle...
                while (0 !== currentIndex) {
                    // Pick a remaining element...
                    randomIndex   = Math.floor(Math.random() * currentIndex)
                    currentIndex -= 1

                    // And swap it with the current element.
                    temporaryValue      = array[currentIndex]
                    array[currentIndex] = array[randomIndex]
                    array[randomIndex]  = temporaryValue
                }

                return array
            },

            startLoopAnimations() {
                this.apngCanvas = this.$refs.apngCanvas
                this.apngContext = this.apngCanvas.getContext('2d')

                let _this = this

                this.animacie.filter( item => this.filterLoopAnimations(item) ).forEach(function (item) {
                    _this.srcLoopAnimacie.push(item.kravicka_animacia_video_nazov)
                })
                this.srcLoopAnimacie.forEach(this.getLoopAnimation)

                this.animacie.filter( item => this.filterActionAnimations(item) ).forEach(function (item) {
                    _this.srcActionAnimacie.push(item.kravicka_animacia_video_nazov)
                })
            },

            getLoopAnimation(loopAnimation) {
                EventService.getApng(loopAnimation)
                    .then( response => this.initLoopAnimation(response.data) )
            },

            initLoopAnimation(apngImage) {
                let apng = parseAPNG(apngImage)
                apng.numPlays = 1
                apng.createImages()
                    .then( _ => this.initLoopPlayer(apng) )
            },

            initLoopPlayer(apng) {
                apng.getPlayer(this.apngContext)
                    .then( loopAnimation => this.prepareLoopAnimation(loopAnimation) )
            },

            prepareLoopAnimation(loopAnimation) {
                this.loopAnimations.push(loopAnimation)
                let index = this.loopAnimations.length - 1

                if (index === 0) {
                    this.loopAnimations[index].play()
                }

                loopAnimation.on( 'end', _ => this.endLoopAnimationHandler(index) )
            },

            endLoopAnimationHandler(index) {
                if ( !this.loopAnimationPaused ) {
                    this.loopAnimations[ this.getNewLoopAnimationIndex(index) ].play()
                }
                else {
                    this.getActionAnimation(this.actionAnimationName)
                }
            },

            getNewLoopAnimationIndex(index) {
                return ( index < this.srcLoopAnimacie.length - 1 ) ? index + 1 : 0
            },

            getActionAnimation(actionAnimationName) {
                EventService.getApng(actionAnimationName)
                    .then( response => this.initActionAnimation(response.data) )
            },

            initActionAnimation(apngImage) {
                let apng = parseAPNG(apngImage)
                apng.numPlays = 1
                apng.createImages()
                    .then( _ => this.initActionPlayer(apng) )
            },

            initActionPlayer(apng) {
                apng.getPlayer(this.apngContext)
                    .then( apngActionAnimation => this.playActionAnimation(apngActionAnimation) )
            },

            playActionAnimation(apngActionAnimation) {
                this.playSound('assets/audio/' + this.animationSound + '.wav')
                this.$emit('hideBubble')
                apngActionAnimation.play()
                apngActionAnimation.on( 'end', this.endActionAnimationHandler )
            },

            endActionAnimationHandler() {
                // pustiť bublinu o 0,5s neskôr
                setTimeout(function(){
                    this.playSound('assets/audio/bubble/' + this.animationBubbleSound + '.wav')
                    this.$emit('showBubble', this.animationBubbleText)
                }.bind(this), 500)

                //this.playSound('assets/audio/bubble/' + this.animationBubbleSound + '.wav')
                //this.$emit('showBubble', this.animationBubbleText)
                this.$emit('animationEnded')
                this.loopAnimationPaused = false
                this.loopAnimations[0].play()
            },

            startActionAnimation(animacia, animaciaZvuk, bublinkaZvuk, bublinkaText) {
                this.loopAnimationPaused  = true
                this.actionAnimationName  = animacia.kravicka_animacia_video_nazov
                this.animationSound       = animaciaZvuk
                this.animationBubbleSound = bublinkaZvuk
                this.animationBubbleText  = bublinkaText
            },

            playSound: function(src) {
                var sound = new Audio(src)
                sound.play()
            },

            filterLoopAnimations: function (value) {
                return value.kravicka_animacia_typ === 'loop'
            },

            filterActionAnimations: function (value) {
                return value.kravicka_animacia_typ === 'action'
            },
        }
    }
</script>